export class TiposDiagnose {
  Id:string = "";
  EmpresaId: number;
  Codigo:string = "";
  Descricao:string = "";
  OrdemRelatorioAcompanhamento: number | null;
}
